import { BaseModel } from "./base.model";

import { BaseListModel } from "./baseList.model";
import { Coupon } from "./coupon.model";

import { IPaymentDiscount } from "../models";

interface INotificationAudienceType extends BaseModel {
	label: string;
}
interface INotificationType extends BaseModel {
	label: string;
}

export enum NotificationDeliveryMethodEnum {
	Socket = "socket",
	Banner = "Banner",
	Push = "Push",
	Announcement = "Announcement"
}
export interface NotificationsModel extends BaseModel {
	body: string;
	countDown: boolean;
	coupon: Coupon;
	couponId: number;
	data: NotificationDataDto;
	duration: NotificationDuration;
	expiresAt?: string;
	isActive: boolean;
	isDismissible: boolean;
	mainImageKey?: string;
	mainImageUrl?: string;
	mobileBody?: string;
	mobileTitle?: string;
	notificationAudienceType: INotificationAudienceType;
	notificationAudienceTypeId: NotificationAudienceTypeIdEnum;
	notificationType: INotificationType;
	notificationTypeId: NotificationTypeId;
	paymentAndDiscount?: IPaymentDiscount;
	sendNow: boolean;
	status: "delivered" | "scheduled";
	title: string;
}

export interface BannerNotification extends NotificationsModel {}

export enum NotificationAudienceTypeIdEnum {
	AllUsers = 1,
	PaidUsers = 2,
	TrialUsers = 3
}

export interface NotificationDuration {
	days?: number;
	hours?: number;
	minutes?: number;
}

export enum NotificationTypeId {
	AdminGeneratedPush = 1,
	AdminGeneratedBanner = 2,
	SystemNotification,
	AdminGeneratedAnnouncement = 6
}

export enum ButtonActionEnum {
	ApplyCoupon = "apply-coupon",
	Dismiss = "dismiss",
	OpenLink = "open-link"
}

export interface NotificationButtonDataDto {
	text: string;
	action: ButtonActionEnum;
	url?: string;
}

interface NotificationDataDto {
	primaryButton?: NotificationButtonDataDto;
	secondaryButton?: NotificationButtonDataDto;
}

export interface ISocketNotificationItem extends BaseModel {
	notificationId: number;
	userId: number;
	readAt: string;
	expiresAt: string;
	isArchived: boolean;
	notification: Partial<NotificationsModel>;
	data?: Record<string, unknown>;
	action?: () => void;
}

export interface ISocketNotifications extends BaseListModel {
	items: (ISocketNotificationItem | NotificationsModel)[];
	totalUnread: number;
}
